module.exports = __webpack_public_path__ + "static/media/logo.6c50a276.jpg";